import _asyncToGenerator from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import fetchAPI from 'utils/http/fetchAPI';
import handleError from 'utils/http/handleError';
import endUserMessages from 'utils/endUserMessages';
import { EXPERIMENTS_ERROR, EXPERIMENTS_SAVING } from 'redux/actionTypes/experiments';
import removeExperiment from './removeExperiment';
var deleteExperiment = function deleteExperiment(experimentId) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch) {
      var errorMessage;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // Delete samples
            dispatch({
              type: EXPERIMENTS_SAVING,
              payload: {
                message: endUserMessages.DELETING_PROJECT
              }
            });
            _context.prev = 1;
            _context.next = 4;
            return fetchAPI("/v2/experiments/".concat(experimentId), {
              method: 'DELETE',
              headers: {
                'Content-Type': 'application/json'
              }
            });
          case 4:
            dispatch(removeExperiment(experimentId));
            _context.next = 11;
            break;
          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](1);
            errorMessage = handleError(_context.t0, endUserMessages.ERROR_DELETING_PROJECT);
            dispatch({
              type: EXPERIMENTS_ERROR,
              payload: {
                message: errorMessage
              }
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 7]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
export default deleteExperiment;